<template>
  <!-- {{ this.total_amount.toFixed(2) }}
       LKR {{ this.split_amount }} -->
  <div class="blackFridaySale">
    <div class="Banner-Box-mob">
      <div class="row">
        <div class="col-md-12 col-sm-12 mt-12">
          <img src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Splash%20Screen.jpg" alt="splah screen"
            style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
      </div>
    </div>
    <div class="Banner-Box-web">
      <div class="row">
        <div class="col-md-12 col-sm-12 mt-12">
          <img
            src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/1669369265114_Primary%20Homepage%20Hero%20banner%20(Live)%201%20(1).jpg"
            alt="homelive banner" style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BlackFridaySale",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style scoped>
.Banner-Box-mob {
  display: none;
}
.Banner-Box-web {
  display: block;
}
@media only screen and (max-width: 600px) {
  .Banner-Box-mob {
    display: block;
  }
  .Banner-Box-web {
    display: none;
  }
}
</style>
